module.exports = __webpack_public_path__ + "static/media/Pic-0279.9198bd86.jpg";